import React, { useState, useRef, useEffect } from "react";
import { FileUpload } from "primereact/fileupload";
import { Toast } from "primereact/toast";
import axios from "../api/axios";
import { Fieldset } from "primereact/fieldset";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Timeline } from "primereact/timeline";
import { axiosPrivate } from "../api/axios";
import { ProgressSpinner } from "primereact/progressspinner";
const pasosSUA = [
  {
    status: "1",
    date: "Seleccione el archivo .SUA que desea cargar al bimestre.",
  },
  {
    status: "2",
    date: "La carga del archivo iniciara de manera automatica.",
  },
  {
    status: "3",
    date: "El finalizar la carga de clic en siguiente.",
  },
];
const pasosTXT = [
  {
    status: "1",
    date: "Seleccione el archivo Aseg.txt de la EBA que desea cargar al bimestre.",
  },
  {
    status: "2",
    date: "La carga del archivo iniciara de manera automatica.",
  },
  {
    status: "3",
    date: "El finalizar la carga de clic en siguiente.",
  },
];

const CargaEBA = ({Auth}) => {
  const toast = useRef(null);
  const stepperRef = useRef(null);
  const [excelURL, setExcelURL] = useState(null); // para guardar el enlace de descarga
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedBimestre, setSelectedBimestre] = useState(null);
  const [opciones, setOpciones] = useState([]);
  const [selectedEmpresa, setSeleccionado] = useState(null);
  const [suaCargado, setSuaCargado] = useState(false);
  const [txtCargado, setTxtCargado] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  useEffect(() => {
    const fetchEmpresas = async () => {
      try {
        //const Authentication=[];
        const datosTransformados =Auth.Empresas.map((item) => ({
          label: item.nombre,
          value: item.rfc,
        }));
        setOpciones(datosTransformados);
      } catch (error) {
        console.error("Error al obtener datos:", error);
      }
    };
    fetchEmpresas();
  }, []);

  const years = [{ name: "2025", code: "2025" },{name: "2026", code: "2026" }];

  const bimestres = [
    { name: "01", code: "01" },
    { name: "02", code: "02" },
    { name: "03", code: "03" },
    { name: "04", code: "04" },
    { name: "05", code: "05" },
    { name: "06", code: "06" },
  ];
  const ValidarForm = () => {
    if (selectedEmpresa === null) {
      showMessage("error", "Error", "Seleccione la empresa.");
      return false;
    }
    if (selectedYear === null) {
      showMessage("error", "Error", "Seleccione el año.");
      return false;
    }
    if (selectedBimestre === null) {
      showMessage("error", "Error", "Seleccione el bimestre.");
      return false;
    }
    return true;
  };
  const showMessage = (tipo, titulo, msg) => {
    toast.current.show({ severity: tipo, summary: titulo, detail: msg });
  };
  const uploadSUA = async ({ files }) => {
    if (ValidarForm() === false) {
      return;
    }
    const suaFile = files[0];

    const formData = new FormData();
    formData.append("archivo", suaFile);
    formData.append("year", selectedYear.code);
    formData.append("bimestre", selectedBimestre.code);
    formData.append("rfc", selectedEmpresa);
    setIsUploading(true);
    try {
      const response = await axios.post("SUA/uploadSUA", formData);
      showMessage("info", "Completado", response.data.message);
      setSuaCargado(true);
    } catch (error) {
      showMessage("error", "Error", error.error);
      setSuaCargado(false);
    } finally {
      setIsUploading(false);
    }
  };
  const uploadTXT = async ({ files }) => {
    if (ValidarForm() === false) {
      return;
    }
    const txtFile = files[0];
    const formData = new FormData();
    formData.append("txtFile", txtFile);
    formData.append("year", selectedYear.code);
    formData.append("bimestre", selectedBimestre.code);
    formData.append("rfc", selectedEmpresa);
    setIsUploading(true);

    try {
      const response = await axios.post("SUA/uploadEBA", formData);
      showMessage("info", "Completado", response.data.message);
      setTxtCargado(true);
    } catch (error) {
      showMessage("error", "Error", error.error);
      setTxtCargado(false);
    }
    finally {
      setIsUploading(false);
    }
  };

  const onSelect = async (event) => {
    if (ValidarForm() === false) {
      return;
    }
    setIsUploading(true);
    try {
      const response = await axiosPrivate.get("SUA/resultExcel", {
        params: {
          year: selectedYear.code,
          bimestre: selectedBimestre.code,
          rfc: selectedEmpresa,
        },
        responseType: "blob",
      });
      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        setExcelURL(downloadUrl);
        showMessage("info","Excel listo para descargar","Haz clic en el enlace.");
        stepperRef.current.nextCallback();
      }
    } catch (error) {
      showMessage("error","Error",error.error);
    } finally {
      setIsUploading(false);
    }
    
  };

  return (
    <>
      {/* <Navbar Authentication={Authentication} /> */}
      <h1>Carga de EBA</h1>
      <Toast ref={toast}></Toast>
      <Fieldset legend="Instrucciones">
        <ul>
          <li>Seleccione la empresa, el año y bimestre que desea cargar.</li>
          <li>Cargue los archivos a comparar</li>
          <li>Al finalizar se generara un hoja de calculo con el resultado</li>
        </ul>
      </Fieldset>
      <div className="card flex justify-content-center">
        <div className="flex flex-column gap-2 mr-2">
          <label htmlFor="empresa">Empresa</label>
          <Dropdown
            id="empresa"
            value={selectedEmpresa}
            options={opciones}
            onChange={(e) => setSeleccionado(e.value)}
            optionLabel="label"
            optionValue="value"
            placeholder="Seleccione la empresa"
            className="w-full md:w-25rem"
          />
        </div>
        <div className="flex flex-column gap-2  mr-2">
          <label htmlFor="username">Año</label>
          <Dropdown
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.value)}
            options={years}
            optionLabel="name"
            placeholder="Seleccione el año"
            className="w-full md:w-16rem"
          />
        </div>
        <div className="flex flex-column gap-2  mr-2">
          <label htmlFor="username">Bimestre</label>
          <Dropdown
            value={selectedBimestre}
            onChange={(e) => setSelectedBimestre(e.value)}
            options={bimestres}
            optionLabel="name"
            placeholder="Seleccione el bimestre"
            className="w-full md:w-16rem"
          />
          <small id="username-help"></small>
        </div>
      </div>
      <div className="card flex justify-content-center">
        <Stepper ref={stepperRef} style={{ flexBasis: "80rem" }} linear>
          {/* <StepperPanel header="SUA">
            <div className="flex flex-column h-20rem">
              <div className="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium">
                <Fieldset className="flex-auto h-20rem">
                  <Timeline
                    value={pasosSUA}
                    opposite={(item) => item.status}
                    content={(item) => (
                      <small className="text-color-secondary">
                        {item.date}
                      </small>
                    )}
                  />
                  <br />
                  <FileUpload
                    className="flex justify-content-center"
                    mode="basic"
                    name="demo"
                    customUpload
                    accept="**"
                    //maxFileSize={1000000}
                    uploadHandler={uploadSUA}
                    auto
                    chooseLabel=".SUA"
                    multiple={false}
                    disabled={isUploading}
                  />
                  {isUploading && (
                  <div className="flex justify-content-center my-3">
                    <ProgressSpinner
                      style={{ width: "50px", height: "50px" }}
                    />
                  </div>
                )}
                </Fieldset>
              </div>
            </div>
            <div className="flex pt-4 justify-content-end">
              <Button
                label="Siguiente"
                icon="pi pi-arrow-right"
                iconPos="right"
                onClick={() => stepperRef.current.nextCallback()}
                disabled={!suaCargado}
              />
            </div>
          </StepperPanel> */}
          <StepperPanel header="TXT">
            <div className="flex flex-column h-20rem">
              <div className="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium">
                <Fieldset className="flex-auto h-20rem">
                  <Timeline
                    value={pasosTXT}
                    opposite={(item) => item.status}
                    content={(item) => (
                      <small className="text-color-secondary">
                        {item.date}
                      </small>
                    )}
                  />
                  <br />
                  <FileUpload
                    className="flex justify-content-center"
                    mode="basic"
                    name="filesTXT"
                    customUpload
                    accept="*/*"
                    maxFileSize={10000000}
                    uploadHandler={uploadTXT}
                    auto
                    chooseLabel="Aseg.txt"
                    disabled={isUploading}
                  />
                  {isUploading && (
                  <div className="flex justify-content-center my-3">
                    <ProgressSpinner
                      style={{ width: "50px", height: "50px" }}
                    />
                  </div>
                )}
                </Fieldset>
              </div>
            </div>
            <div className="flex pt-4 justify-content-between">
              <Button
                label="Anterior"
                severity="secondary"
                icon="pi pi-arrow-left"
                onClick={() => stepperRef.current.prevCallback()}
              />
              <Button
                label="Finalizar"
                icon="pi pi-arrow-right"
                iconPos="right"
                onClick={() => {
                  onSelect();
                  
                }}
                //disabled={!zipCargado}
              />
              {/* <Button
                label="Siguiente"
                icon="pi pi-arrow-right"
                iconPos="right"
                onClick={() => stepperRef.current.nextCallback()}
                disabled={!txtCargado}
              /> */}
            </div>
          </StepperPanel>
          {/* <StepperPanel header="Recibos del bimestre">
            <div className="flex flex-column h-20rem">
              <div className="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium">
                <Fieldset className="flex-auto h-20rem">
                  <Timeline
                    value={pasosZIP}
                    opposite={(item) => item.status}
                    content={(item) => (
                      <small className="text-color-secondary">
                        {item.date}
                      </small>
                    )}
                  />
                  <br />
                  <FileUpload
                    className="flex justify-content-center"
                    mode="basic"
                    name="filesXML[]"
                    customUpload
                    accept="**"
                    maxFileSize={900000000}
                    uploadHandler={uploadXMLs}
                    auto
                    chooseLabel=".zip"
                    disabled={isUploading}
                  />
{isUploading && (
                  <div className="flex justify-content-center my-3">
                    <ProgressSpinner
                      style={{ width: "50px", height: "50px" }}
                    />
                  </div>
                )}
                </Fieldset>
                
              </div>
            </div>
            <div className="flex pt-4 justify-content-between">
              <Button
                label="Anterior"
                severity="secondary"
                icon="pi pi-arrow-left"
                onClick={() => stepperRef.current.prevCallback()}
              />
              <Button
                label="Finalizar"
                icon="pi pi-arrow-right"
                iconPos="right"
                onClick={() => {
                  onSelect();
                  
                }}
                disabled={!zipCargado}
              />
            </div>
          </StepperPanel> */}
          <StepperPanel header="Resultados">
            <div className="flex flex-column h-20rem">
              <div className="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium">
                <Fieldset className="flex-auto h-20rem">
                  {excelURL && (
                    <div className="mt-3">
                      <a
                        href={excelURL}
                        download="coincidencias.xlsx"
                        className="p-button p-component p-button-outlined p-button-success"
                      >
                        Descargar Excel de Coincidencias
                      </a>
                    </div>
                  )}
                </Fieldset>
              </div>
            </div>
            <div className="flex pt-4 justify-content-between">
              <Button
                label="Anterior"
                severity="secondary"
                icon="pi pi-arrow-left"
                onClick={() => stepperRef.current.prevCallback()}
              />
            </div>
          </StepperPanel>
        </Stepper>
      </div>
    </>
  );
};
export default CargaEBA;
